import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Briefcase, Users, Calendar } from "@phosphor-icons/react";
import { JobBoard } from "./JobBoard";
import { CandidatePipeline } from "./CandidatePipeline";
import { InterviewScheduler } from "./InterviewScheduler";

export function RecruitmentDashboard() {
  const [activeTab, setActiveTab] = useState("jobs");

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="flex flex-col gap-2">
        <h2 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-slate-900 to-slate-700 dark:from-white dark:to-slate-300">
          Recruitment & ATS
        </h2>
        <p className="text-slate-500 dark:text-slate-400">
          Manage job postings, track candidates, and schedule interviews.
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-3 lg:w-auto">
          <TabsTrigger value="jobs" className="gap-2">
            <Briefcase className="w-4 h-4" />
            <span className="hidden md:inline">Job Board</span>
          </TabsTrigger>
          <TabsTrigger value="pipeline" className="gap-2">
            <Users className="w-4 h-4" />
            <span className="hidden md:inline">Candidates</span>
          </TabsTrigger>
          <TabsTrigger value="interviews" className="gap-2">
            <Calendar className="w-4 h-4" />
            <span className="hidden md:inline">Interviews</span>
          </TabsTrigger>
        </TabsList>

        <div className="mt-6">
          <TabsContent value="jobs" className="space-y-4">
            <JobBoard />
          </TabsContent>

          <TabsContent value="pipeline" className="space-y-4">
            <CandidatePipeline />
          </TabsContent>

          <TabsContent value="interviews" className="space-y-4">
            <InterviewScheduler />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
}
